import { css } from 'lit';

const IxFileChipStyles = css`
  :host {
    display: flex;
  }

  .file-chip {
    align-items: center;
    background: #f5f7ff;
    display: flex;
    padding: 4px 8px;
    height: 40px;
  }

  .file-chip__name {
    cursor: pointer;
    margin-right: 10px;

    font-size: var(--ix-file-chip-font-size, var(--text-small-size, 1rem));
    line-height: var(
      --ix-file-chip-line-height,
      var(--text-small-line-height, 1.3rem)
    );
    letter-spacing: var(
      --ix-file-chip-letter-spacing,
      var(--text-small-letter-spacing, 0.15px)
    );
    color: var(--ix-file-chip-color, var(--clr-on-surface, 'inherit'));
  }

  .file-chip__name:focus {
    outline: none;
  }

  .file-chip__name:focus-visible {
    outline: 2px solid var(--clr-on-surface-primary, #1456e0);
    outline-offset: 2px;
  }

  .delete-icon {
    color: var(--clr-critical, #db0028);
  }
`;

export default IxFileChipStyles;
